import { useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { UserContext } from "../providers/UserProvider";

const REGISTER_DEFAULT_VALUES = {
  name: "",
  email: "",
  password: "",
  passwordConfirmation: "",
};

export default function useRegister() {
  const [values, setValues] = useState(REGISTER_DEFAULT_VALUES);
  const [errors, setErrors] = useState(null);
  const { storeLoggedinUser } = useContext(UserContext);
  const history = useHistory();
  let location = useLocation();

  /**
   * Function to handle the form values on change.
   *
   * @param e
   */
  function onChange(e) {
    setValues({ ...values, [e.target.name]: e.target.value });
  }

  /**
   * Function to handle the submit when someone logs in.
   *
   * @param e
   * @returns {Promise<any>}
   */
  async function onSubmit(e) {
    let { from } = location.state || { from: { pathname: "/" } };
    e.preventDefault();
    const settings = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({ ...values }),
    };
    try {
      const res = await (
        await fetch(global.api + "user/register", settings)
      ).json();

      localStorage.setItem("accessToken", res.data.token);

      if (res.errors) {
        setErrors(res.errors);
      }

      if (res.data) {
        console.log(res.data.user);
        storeLoggedinUser(res.data);
      }
    } catch (errors) {
      console.log(errors);
    }
  }

  return {
    onChange,
    onSubmit,
    values,
    errors,
  };
}
